import axiosInstance from "./axiosInstance";
import axiosInstance11 from "./axiosInstance11";
import axiosInstance2 from "./axiosInstance2";
import axiosInstance5 from "./axiosInstancePost1";
import axiosInstanceknwinfosvcGet1 from "./axiosInstanceknwinfosvcGet1";
import axiosInstanceEduinfosvcPost from "./axiosInstanceEduinfosvcPost";
import axiosInstanceSearchGet from "./axiosInstanceSearchGet";
import axiosInstanceEduV2Get from "./axiosInstanceEduV2Get";
import axiosInstanceknwinfoV3Get from "./axiosInstanceKnwinfoV3Get";
import axiosInstanceEduinfosvcPost1 from "./axiosInstanceEduinfosvcPost1";
import axiosInstanceSearchSchool from "./axiosInstanceSearchSchool";
import axiosInstanceAcademyV2Get from "./axiosInstanceAcademyV2Get";
import axiosInstanceknwinfosvcGet2 from "./axiosInstanceknwinfosvcGet2";
import axiosInstancePostRelatedSchool from "./axiosInstancePostRelatedSchool";
import getApplicationLabel from "./getApplicationLabel";
import getPicklist from "./getPicklist";
import getSchoolLists from "./getSchoolLists";

export const fetchData = async (pageNameId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        pageNameId: pageNameId,
      },
    };

    const response = await axiosInstance.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchData1 = async (pageNameId) => {
  try {
    // const requestOptions = {
    //   method: "POST",
    //   params: {
    //     pageNameId: pageNameId,
    //   },
    // };
    const response = await axiosInstance11.post("", { pageNameId });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// export const fetchDataPost = async (pageNameId) => {
//   try {
//     const response = await axiosInstancePost.post("", { pageNameId });
//     return response.data;
//   } catch (error) {
//     console.log("Error fetching data:", error);
//     return null;
//   }
// };

export const fetchSearchData = async (variables) => {
  try {
    const response = await axiosInstance2.post("", variables);

    return response;
  } catch (error) {
    console.log("Error fetching data:", error);
    // throw new Error("Failed to fetch search data");
    return null;
  }
};



export function postMethod(url: string, bodyData: any) {
  return axiosInstance5
    .post(url, bodyData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

export const fetchDataSearch = async () => {
  try {
    const requestOptions = {
      method: "GET",
    };
    const response = await axiosInstanceSearchGet.get("/", requestOptions);
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const fetchKnwinfoDataGet1 = async (pageNameId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        pageNameId: pageNameId,
      },
    };

    const response = await axiosInstanceknwinfosvcGet1.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchKnwinfoDataGet2 = async (pageNameId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        pageNameId: pageNameId,
      },
    };

    const response = await axiosInstanceknwinfosvcGet2.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchEduinfosvcPost = async (pageNameId) => {
  try {
    // const requestOptions = {
    //   method: "GET",
    //   params: {
    //     pageNameId: pageNameId,
    //   },
    // };

    const response = await axiosInstanceEduinfosvcPost.post("", { pageNameId });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchData2 = async (pageNameId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        pageNameId: pageNameId,
      },
    };

    const response = await axiosInstanceEduV2Get.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const knwinfoV3fetchData = async (pageNameId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        pageNameId: pageNameId,
      },
    };

    const response = await axiosInstanceknwinfoV3Get.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchEduinfosvcPost1 = async (isScholarshipAvailable) => {
  try {
    const response = await axiosInstanceEduinfosvcPost1.post("", {
      isScholarshipAvailable,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchSchoolCardData = async () => {
  try {
    const response = await axiosInstanceSearchSchool.post("");
    return response;
  } catch (error) {
    console.log("Error fetching data:", error);
    // throw new Error("Failed to fetch search data");
    return null;
  }
};

export const academyFetchData = async (pageNameId) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        pageNameId: pageNameId,
      },
    };

    const response = await axiosInstanceAcademyV2Get.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchRelatedSchoolCardData = async (relatedschools) => {
  try {
    const response = await axiosInstancePostRelatedSchool.post("", {
      relatedschools,
    });
    return response;
  } catch (error) {
    console.log("Error fetching data:", error);
    // throw new Error("Failed to fetch search data");
    return null;
  }
};


export const applicationLabelFetchData = async (name:string) => {
  try {
    const requestOptions = {
      method: "GET",
      params: {
        name:name,
      },
    };

    const response = await getApplicationLabel.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchPicklistData = async () => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getPicklist.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchSchoolListData = async () => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getSchoolLists.get("", requestOptions);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchAcademicListData = async (id) => {
  try {
    const requestOptions = {
      method: "GET",
    };

    const response = await getSchoolLists.get(`/${id}`, requestOptions);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response?.status;
  }
};